<template>
    <div v-if="!hash_acesso_biblioteca" class="login-container">
        <div class="login-image">
            <img src="@/assets/logos/logo-branco.png" alt="Login Image" />
        </div>
        <div class="login-box">
            <h2 class="title">Login</h2>
            <form @submit.prevent="handleLogin">
                <div class="form-group">
                    <input :placeholder="emailPlaceholder" v-model="email" type="email" required :disabled="isLoading"
                        class="input" />
                </div>
                <div class="form-group password-group">
                    <input :placeholder="passwordPlaceholder" v-model="password" :type="showPassword ? 'text' : 'password'" required
                        :disabled="isLoading" class="input" />
                    <button type="button" class="btn-toggle-password" @click="showPassword = !showPassword">
                        <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                    </button>
                </div>
                <button class="btn-login" type="submit" :disabled="isLoading" :class="{ 'loading': isLoading }">
                    <span v-if="!isLoading">Entrar</span>
                    <div v-else class="spinner-login"></div>
                </button>
            </form>
        </div>
        <AlertModal v-if="showModal" :message="modalMessage" @close="handleModalClose" />
    </div>
    <div v-else>
        <div class="spinner-container">
            <div class="spinner"></div>

        </div>
    </div>
</template>

<script>
import '../styles/Login.css';
import '../styles/Global.css';
import request from '../router/request.js';
import AlertModal from '../components/AlertModal.vue';

export default {
    name: 'LoginView',
    components: { AlertModal },
    data() {
        return {
            email: '',
            password: '',
            showPassword: false,
            showModal: false,
            modalMessage: '',
            isAuthenticated: false,
            hash_acesso_biblioteca: null,
            isLoading: false,
            emailPlaceholder: 'Digite seu Email',
            passwordPlaceholder: 'Digite sua Senha',
        };
    },
    methods: {
        async checkAuth() {
            const token = localStorage.getItem('token');
            if (!token || token === '0') {
                this.isAuthenticated = false;
                return;
            }

            // try {
            //     await request.get('/usuario/dados', {
            //         headers: { Authorization: `Bearer ${token}` }
            //     });
            //     this.$router.push('/home');
            // } catch (err) {
            //     localStorage.removeItem('token');
            // }
        },
        handleModalClose() {
            this.showModal = false;
            this.modalMessage = '';
        },
        handleLogin() {
            if (!this.email || !this.password) {
                this.modalMessage = 'Por favor, preencha todos os campos.';
                this.showModal = true;
                return;
            }

            localStorage.removeItem('token');
            localStorage.removeItem('user');

            this.isLoading = true;

            this.$store.dispatch('login', {
                email: this.email,
                password: this.password
            })
                .then(() => {
                    this.isAuthenticated = true;
                    this.$router.push('/home');
                })
                .catch(error => {
                    console.error('Erro ao fazer login:', error);
                    console.log("DATA:", error.response?.data);
                    console.log("STATUS:", error.response?.status);

                    if (error.message && error.message.includes('não autorizado')) {
                        this.modalMessage = 'Este perfil deve usar o acesso via LTI, não o login tradicional.';
                    } else {
                        this.modalMessage = 'Login falhou. Verifique suas credenciais.';
                    }

                    this.showModal = true;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        handleUrlParams() {
            this.hash_acesso_biblioteca = this.$route.query.hash
            if (this.hash_acesso_biblioteca) {
                request.post('portal/ValidarAcessobiblioteca', {
                    hash_acesso_biblioteca: this.hash_acesso_biblioteca
                })
                    .then(response => {
                        console.log('resposta login: ', response.data);
                        localStorage.setItem('token', response.data.token);
                        this.modalMessage = 'Acesso biblioteca validado com sucesso!';
                        this.showModal = true;
                        this.isAuthenticated = true;
                    })
                    .catch(error => {
                        console.error('Erro ao validar hash de acesso biblioteca:', error);
                        this.hash_acesso_biblioteca = null;
                        console.log("DATA:", error.response?.data);
                        console.log("STATUS:", error.response?.status);
                    });
            }
        },
    },
    mounted() {
        this.checkAuth();
        this.handleUrlParams();
    }
};
</script>
